import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import A from './comps/A';
import B from './comps/B';
import C from './comps/C';
import D from './comps/D';
import E from './comps/E';
import F from './comps/F';
import G from './comps/G';
import H from './comps/H';
import I from './comps/I';
import J from './comps/J';
import K from './comps/K';
import L from './comps/L';

const CES2026: React.FC = () => {
    if (typeof window !== 'undefined') {
        if (!window?.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
    }

    return (
        <div className={`ces-2026 ${css.section}`}>
            <A />
            <B />
            <C />
            <D />
            <E />
            <F />
            <G />
            <H />
            <I />
            <J />
            <K />
            <L />
        </div>
    );
};

export default CES2026;
